export enum SubscriptionStatus {
    active = 'active',
    canceled = 'canceled',
    inactive = 'inactive',
    paused = 'paused',
}